import React from 'react'
import PropTypes from 'prop-types'
import { FormattedMessage } from 'react-intl'
import Button from '../Button'

const Footer = ({
  goBack,
  updateBooking,
  peopleValid
}) => (
  <div className="flex mb-16 mt-12">
    <div className="flex-grow">
      <Button onClick={goBack} bgCss='bg-grey'>
        <FormattedMessage id="booking.people.buttonBack" defaultMessage="Back" />
      </Button>
    </div>
    <Button onClick={updateBooking} className={`${peopleValid() ? '' : 'opacity-50'}`}>
      <FormattedMessage id="booking.people.buttonContinue" defaultMessage="Continue" />
    </Button>
  </div>
)

Footer.propTypes = {
  goBack: PropTypes.func.isRequired,
  updateBooking: PropTypes.func.isRequired,
  peopleValid: PropTypes.func.isRequired
}

export default Footer